import { StyleSheet, css } from 'aphrodite/no-important';

const Category = ({cat, eventsData, categoryColor, isVisible, scaleFactor, firstYear, lastYear}) => {
  if(!isVisible) return null;
  const duration = lastYear - firstYear;
  const firstCentury = Math.floor(firstYear / 100) * 100;
  const negativeYears = firstCentury < 0 ? firstCentury * -1 : 0;

  return (
    <div className={css(styles.events)} style={{gridTemplateColumns: `repeat(${negativeYears+duration}, ${scaleFactor}px [col-start])`}}>
       {
        Object.keys(eventsData[cat]).map((eventId) => {
          const event = eventsData[cat][eventId];
          
          const isOneYearEvent = event.duration <= 1;
          const isShortEvent = event.duration < (50 / scaleFactor) && !isOneYearEvent;
          
          const eventStyle = [styles.event];
          const lblStyle = [styles.lbl];
          
          if(isShortEvent) {
            eventStyle.push(styles.hoverLabel);
            lblStyle.push(styles.lblHasHover);
          } else if(isOneYearEvent) {
            lblStyle.push(styles.lblXl);
          }
          
          return (
            <div 
              key={eventId} 
              className={css(eventStyle)}
              data-event={event.title}
              style={{
                gridColumn: `${parseInt(event.start) + negativeYears} / span ${event.duration}`,
                gridRow: event.row,
              }} 
            >
              <div
                className={css(styles.bar)}
                style={{backgroundColor: categoryColor, maxWidth: `${event.duration * scaleFactor}px`}}
              />
              <div className={css(lblStyle)}>{event.title}</div>
            </div>
          )
        })
      }
    </div>
  )
}

const styles = StyleSheet.create({
  events: {
    paddingTop: '25px',
    display: 'grid',
  },
  event: {
    marginTop: '3px',
  },
  bar: {
    minHeight: '4px',
    minWidth: '4px',
    borderRadius: '6px',
    border: '1px solid #FFF',
  },
  lbl: {
    padding: '2px',
    color: '#333',
    fontSize: '11px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  lblXl: {
    minWidth: '100px',
    maxWidth: '100px',
  },
  lblHasHover: {
    display: 'none',
  },
  hoverLabel: {
    position: 'relative',
    ':hover:after': {
      fontSize: '11px',
      position: 'absolute',
      width: 'max-content',
      color: "#FFF",
      backgroundColor: '#000',
      borderRadius: '3px',
      padding: '6px 6px',
      top: '10px',
      content: 'attr(data-event)',
      maxWidth: '100px',
      left: '50%',
      transform: 'translateX(-50%)',
      zIndex: 5,
    },
    ':hover:before':{
      content: "''",
      overflow: 'auto',
      position: 'absolute',
      top: '0px',
      left: '50%',
      height: 'auto',
      minWidth: 'auto',
      transform: 'translateX(-50%)',
      border: '5px solid #000',
      borderColor: 'transparent  transparent #000 transparent ',
    }
  }
});


export default Category;